import { ClassSchedule, ExamSchedule } from './types';

export const yearOptions = [
  { id: 1, name: '2025' },
  { id: 2, name: '2024' },
  { id: 3, name: '2023' },
  { id: 4, name: '2022' },
  { id: 5, name: '2021' },
  { id: 6, name: '2020' },
  { id: 7, name: '2019' },
  { id: 8, name: '2018' },
  { id: 9, name: '2017' },
  { id: 10, name: '2016' },
  { id: 11, name: '2015' },
  { id: 12, name: '2014' },
  { id: 13, name: '2013' },
  { id: 14, name: '2012' },
  { id: 15, name: '2011' },
  { id: 16, name: '2010' },
  { id: 17, name: '2009' },
  { id: 18, name: '2008' },
  { id: 19, name: '2007' },
  { id: 20, name: '2006' },
  { id: 21, name: '2005' },
  { id: 22, name: '2004' },
  { id: 23, name: '2003' },
  { id: 24, name: '2002' },
  { id: 25, name: '2001' },
  { id: 26, name: '2000' },
];

export const monthOptions = [
  { id: 1, name: 'January' },
  { id: 2, name: 'February' },
  { id: 3, name: 'March' },
  { id: 4, name: 'April' },
  { id: 5, name: 'May' },
  { id: 6, name: 'June' },
  { id: 7, name: 'July' },
  { id: 8, name: 'August' },
  { id: 9, name: 'September' },
  { id: 10, name: 'October' },
  { id: 11, name: 'November' },
  { id: 12, name: 'December' },
];

export const scheduleTypes = [
  { id: 1, name: 'Exam' },
  { id: 2, name: 'Class' },
];

export const classSchedule: ClassSchedule[] = [
  {
    class: 'Second',
    section: 'A',
    startDate: '2025-01-01',
    endDate: '2025-07-01',
    scheduleType: 'Class',
    scheduleStructure: [
      {
        day: 'Monday',
        schedule: [
          {
            subject_name: 'English Literature',
            teacher: 'Priya Sharma',
            startTime: [8, 45],
            endTime: [9, 30],
          },
          {
            subject_name: 'Science',
            teacher: 'Raman Gautam',
            startTime: [9, 30],
            endTime: [10, 15],
          },
          {
            subject_name: 'Maths',
            teacher: 'Gautam Adani',
            startTime: [10, 15],
            endTime: [11, 0],
          },
          {
            subject_name: 'History',
            teacher: 'Neha Verma',
            startTime: [11, 0],
            endTime: [11, 45],
          },
          {
            subject_name: 'Geography',
            teacher: 'Suresh Mehta',
            startTime: [11, 45],
            endTime: [12, 30],
          },
          {
            subject_name: 'Computer Science',
            teacher: 'Rajiv Kapoor',
            startTime: [12, 30],
            endTime: [13, 15],
          },
        ],
      },
      {
        day: 'Tuesday',
        schedule: [
          {
            subject_name: 'English Literature',
            teacher: 'Priya Sharma',
            startTime: [8, 45],
            endTime: [9, 30],
          },
          {
            subject_name: 'Science',
            teacher: 'Raman Gautam',
            startTime: [9, 30],
            endTime: [10, 15],
          },
          {
            subject_name: 'Maths',
            teacher: 'Gautam Adani',
            startTime: [10, 15],
            endTime: [11, 0],
          },
          {
            subject_name: 'History',
            teacher: 'Neha Verma',
            startTime: [11, 0],
            endTime: [11, 45],
          },
          {
            subject_name: 'Geography',
            teacher: 'Suresh Mehta',
            startTime: [11, 45],
            endTime: [12, 30],
          },
          {
            subject_name: 'Computer Science',
            teacher: 'Rajiv Kapoor',
            startTime: [12, 30],
            endTime: [13, 15],
          },
        ],
      },
      {
        day: 'Wednesday',
        schedule: [
          {
            subject_name: 'English Literature',
            teacher: 'Priya Sharma',
            startTime: [8, 45],
            endTime: [9, 30],
          },
          {
            subject_name: 'Science',
            teacher: 'Raman Gautam',
            startTime: [9, 30],
            endTime: [10, 15],
          },
          {
            subject_name: 'Maths',
            teacher: 'Gautam Adani',
            startTime: [10, 15],
            endTime: [11, 0],
          },
          {
            subject_name: 'History',
            teacher: 'Neha Verma',
            startTime: [11, 0],
            endTime: [11, 45],
          },
          {
            subject_name: 'Geography',
            teacher: 'Suresh Mehta',
            startTime: [11, 45],
            endTime: [12, 30],
          },
          {
            subject_name: 'Computer Science',
            teacher: 'Rajiv Kapoor',
            startTime: [12, 30],
            endTime: [13, 15],
          },
        ],
      },
      {
        day: 'Thursday',
        schedule: [
          {
            subject_name: 'English Literature',
            teacher: 'Priya Sharma',
            startTime: [8, 45],
            endTime: [9, 30],
          },
          {
            subject_name: 'Science',
            teacher: 'Raman Gautam',
            startTime: [9, 30],
            endTime: [10, 15],
          },
          {
            subject_name: 'Maths',
            teacher: 'Gautam Adani',
            startTime: [10, 15],
            endTime: [11, 0],
          },
          {
            subject_name: 'History',
            teacher: 'Neha Verma',
            startTime: [11, 0],
            endTime: [11, 45],
          },
          {
            subject_name: 'Geography',
            teacher: 'Suresh Mehta',
            startTime: [11, 45],
            endTime: [12, 30],
          },
          {
            subject_name: 'Computer Science',
            teacher: 'Rajiv Kapoor',
            startTime: [12, 30],
            endTime: [13, 15],
          },
        ],
      },
      {
        day: 'Friday',
        schedule: [
          {
            subject_name: 'English Literature',
            teacher: 'Priya Sharma',
            startTime: [8, 45],
            endTime: [9, 30],
          },
          {
            subject_name: 'Science',
            teacher: 'Raman Gautam',
            startTime: [9, 30],
            endTime: [10, 15],
          },
          {
            subject_name: 'Maths',
            teacher: 'Gautam Adani',
            startTime: [10, 15],
            endTime: [11, 0],
          },
          {
            subject_name: 'History',
            teacher: 'Neha Verma',
            startTime: [11, 0],
            endTime: [11, 45],
          },
          {
            subject_name: 'Geography',
            teacher: 'Suresh Mehta',
            startTime: [11, 45],
            endTime: [12, 30],
          },
          {
            subject_name: 'Computer Science',
            teacher: 'Rajiv Kapoor',
            startTime: [12, 30],
            endTime: [13, 15],
          },
        ],
      },
    ],
  },
];

export const examSchedule: ExamSchedule[] = [
  {
    class: 'First',
    section: 'A',
    scheduleType: 'Exam',
    examName: 'Sessional',
    examYear: '2025',
    examMonth: 'March',
    schedule: [
      {
        subject: 'English Literature',
        dateOfExam: '2025-01-01',
        startTime: [8, 30],
        endTime: [11, 30],
      },
      {
        subject: 'Mathematics',
        dateOfExam: '2025-01-02',

        startTime: [8, 30],
        endTime: [11, 30],
      },
    ],
    seatingPlan: [
      {
        examClass: 'Fourth',
        examSection: 'B',
        rollNoStart: 1,
        rollNoEnd: 10,
      },
      {
        examClass: 'Fifth',
        examSection: 'C',
        rollNoStart: 10,
        rollNoEnd: 20,
      },
    ],
  },
  {
    class: 'Second',
    section: 'B',
    scheduleType: 'Exam',
    examName: 'Final',
    examYear: '2025',
    examMonth: 'March',
    schedule: [
      {
        subject: 'Science',
        dateOfExam: '2025-02-10',

        startTime: [9, 0],
        endTime: [12, 0],
      },
      {
        subject: 'Social Studies',
        dateOfExam: '2025-02-11',
        startTime: [9, 0],
        endTime: [12, 0],
      },
    ],
    seatingPlan: [
      {
        examClass: 'Sixth',
        examSection: 'A',
        rollNoStart: 1,
        rollNoEnd: 15,
      },
      {
        examClass: 'Sixth',
        examSection: 'B',
        rollNoStart: 16,
        rollNoEnd: 30,
      },
    ],
  },
  {
    class: 'Third',
    section: 'C',
    scheduleType: 'Exam',
    examName: 'Midterm',
    examYear: '2025',
    examMonth: 'March',
    schedule: [
      {
        subject: 'Physics',
        dateOfExam: '2025-03-05',
        startTime: [8, 45],
        endTime: [11, 45],
      },
      {
        subject: 'Chemistry',
        dateOfExam: '2025-03-06',
        startTime: [8, 45],
        endTime: [11, 45],
      },
    ],
    seatingPlan: [
      {
        examClass: 'Seventh',
        examSection: 'A',
        rollNoStart: 1,
        rollNoEnd: 20,
      },
      {
        examClass: 'Seventh',
        examSection: 'B',
        rollNoStart: 21,
        rollNoEnd: 40,
      },
    ],
  },
  {
    class: 'Fourth',
    section: 'D',
    scheduleType: 'Exam',
    examName: 'Pre-Final',
    examYear: '2025',
    examMonth: 'March',
    schedule: [
      {
        subject: 'Computer Science',
        dateOfExam: '2025-04-10',
        startTime: [9, 30],
        endTime: [12, 30],
      },
      {
        subject: 'Economics',
        dateOfExam: '2025-04-11',
        startTime: [9, 30],
        endTime: [12, 30],
      },
    ],
    seatingPlan: [
      {
        examClass: 'Eighth',
        examSection: 'A',
        rollNoStart: 1,
        rollNoEnd: 25,
      },
      {
        examClass: 'Eighth',
        examSection: 'B',
        rollNoStart: 26,
        rollNoEnd: 50,
      },
    ],
  },
];

export const tableItemStyle = (
  length: number
): {
  backgroundColor: string;
  border: string;
  width: string;
  textAlign: string;
  fontSize: string;
  fontWeight: string;
  padding: string;
} => {
  const columnWidth = 100 / length;
  return {
    backgroundColor: '#F5F5F5',
    border: '2px solid black',
    width: `${columnWidth}%`,
    textAlign: 'center',
    fontSize: '100%',
    fontWeight: 'bold',
    padding: '1%',
  };
};

export const scheduleStructure = [
  {
    day: 'Monday',
    schedule: [],
  },
  {
    day: 'Tuesday',
    schedule: [],
  },
  {
    day: 'Wednesday',
    schedule: [],
  },
  {
    day: 'Thursday',
    schedule: [],
  },
  {
    day: 'Friday',
    schedule: [],
  },
  {
    day: 'Saturday',
    schedule: [],
  },
];

export const headingStyle = { fontSize: '14px', fontWeight: 'bold' };

export const teacherScheduleSample = [
  {
    scheduleId: 1,
    employeeId: '213013',
    startDate: '2025-06-10',
    endDate: '2025-06-17',
    userType: 1,
    instituteId: '23232',
    scheduleStructure: [
      {
        day: 'Monday',
        schedule: [
          {
            class: 'First',
            endTime: [10, 0],
            section: 'A',
            startTime: [9, 0],
            subject_name: 'Hindi',
          },
        ],
      },
      {
        day: 'Tuesday',
        schedule: [],
      },
      {
        day: 'Wednesday',
        schedule: [],
      },
      {
        day: 'Thursday',
        schedule: [],
      },
      {
        day: 'Friday',
        schedule: [],
      },
      {
        day: 'Saturday',
        schedule: [],
      },
    ],
  },
];
